export {
  getSearchMetadata,
  getGuidedSearchData,
  getRecommendationsAnalytics,
  getAdvertisementsAnalytics,
  getRequestId,
  selectSearchDiagnosticsDomain,
} from "../domains/diagnostics/selectors";
export {
  hasSelectedFacets,
  hasFacets,
  getVisibleFacets,
  hasColourFacet,
  hasActiveFacetFilters,
  getFacetsWithSelections,
  getSelectedFacetValues,
  getFacetSelectedValueNames,
  getFacetSelectedCount,
  getSelectedValuesForFacet,
  getAllAppliedRefinements,
  selectSearchFiltersDomain,
  hasSearchFacets,
} from "../domains/filters/selectors";
export {
  getPageSize,
  getSearchTerm,
  getSort,
  getSuggestTerms,
  isExactMatch,
  getAdditionalQueryParams,
  getPersonalisationParams,
  getSearchPassesName,
  selectSearchQueryDomain,
} from "../domains/query/selectors";
export {
  getOffset,
  getProducts,
  getPages,
  getPaginationData,
  getPaginationInitial,
  getPaginationMax,
  getItemCount,
  getShowLoadMore,
  getShowLoadPrevious,
  getTileToFocus,
  getHasShowableVideo,
  selectSearchResultsDomain,
  selectSearchShowLoadMore,
  selectSearchShowLoadPrevious,
  selectSearchTileToFocus,
} from "../domains/results/selectors";
export {
  getIsLoading,
  getIsLoadingPrevious,
  getImageGalleryOnboardDismissed,
  getIsNewSearch,
  getIsNewPage,
  selectSearchUiDomain,
  selectSearchIsInitialLoading,
  selectSearchIsPagingForward,
  selectSearchIsPagingBackward,
  selectSearchIsNewSearch,
  selectSearchIsNewPage,
} from "../domains/ui/selectors";
export {
  selectSearchPriceRangeDomain,
  getPriceSliderState,
  getSelectedPriceRangeRefinement,
} from "../domains/priceRange/selectors";
export { selectSearchState } from "../domains/selectors/shared";

export const isUrlWithQueryString = (url) => url.indexOf("?") !== -1;
